import { DefaultRootState } from 'react-redux';

import { PrimaryEducation } from 'src/models/resume/resumeCommon.types';

export const selectApplicantResumePrimaryEducation = ({ applicantResume }: DefaultRootState): PrimaryEducation[] =>
    applicantResume.primaryEducation ?? [];
